import React from "react";
import { ArticleList } from "@/components/ArticleList";

export default function News() {
  return (
    <ArticleList
      type="news"
      label="The Feed"
      title="Latest Intelligence"
      subtitle="What's moving markets, what matters, and why from global to Southeast Asia."
    />
  );
}
